import { render, staticRenderFns } from "./PresupuestoShow.vue?vue&type=template&id=d4028ad4&scoped=true&"
import script from "./PresupuestoShow.vue?vue&type=script&lang=js&"
export * from "./PresupuestoShow.vue?vue&type=script&lang=js&"
import style0 from "./PresupuestoShow.vue?vue&type=style&index=0&id=d4028ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4028ad4",
  null
  
)

export default component.exports